import { Route, Switch } from "react-router-dom";
import PagarListagemPage from "./Listagem";

function PagarPages() {
  return (
    <Switch>
      <Route
        exact
        path="/financeiro/despesa/pagar"
        component={PagarListagemPage}
      />
    </Switch>
  );
}

export default PagarPages;
